import {Component} from "@angular/core";
import {RouteService} from "../../../../services/routeService";
import util from "util";
import {DICTIONARY} from "../../../../dictionary";
import {GeneralService} from "../../../../services/generalService";
import {NotificationService} from "../../../../services/notificationService";
import _ from "lodash";

@Component({
	selector: "mx-resolver-tool-component",
	templateUrl: "./mx-resolver-tool.component.html",
})
export class MxResolverToolComponent {
	constructor(private rs:RouteService,
				private gs:GeneralService,
				private ns:NotificationService) {}

	domainTxt;
	resolveDomainInProcess;
	resolveDomainResult;

	resolveDomain = () => {
		if (!this.domainTxt) {
			return;
		}
		this.resolveDomainResult = null;

		this.domainTxt = this.domainTxt.trim();
		if (!this.gs.isValidDomain(this.domainTxt)) {
			return this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.invalidDomain, this.domainTxt));
		}

		this.resolveDomainInProcess = true;

		this.rs.runTool('mxResolver', {domain: this.domainTxt}).then(res => {
			const validMxRecords = getValidMxRecords(res);
			if (!validMxRecords.length) {
				this.resolveDomainResult = null;
				this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.noMxRecordsFound, this.domainTxt));
			}
			else {
				this.resolveDomainResult = validMxRecords;
			}
			this.resolveDomainInProcess = false;
		}, (err) => {
			this.resolveDomainInProcess = false;
			this.resolveDomainResult = null;
			if (!err?.data?.display_bar) {
				const notFoundMessage = err?.data?.message || util.format(DICTIONARY.ERRORS.noMxRecordsFound, this.domainTxt);
				this.ns.showWarnMessage(notFoundMessage);
			}
		});
	};
	protected readonly _ = _;
}

function getValidMxRecords(records) {
	if (!Array.isArray(records)) {
		return [];
	}

	return records.filter(record => {
		const hostname = (record?.exchange || '').trim();
		return hostname && hostname !== '.';
	});
}
